import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideoCameraBackIcon(props: IconProps) {
    return <Icon {...props} iconKey={"video_camera_back"}/>
}
